// extracted by mini-css-extract-plugin
export default {"link":"_3sib94Eiy5TIInBbCfV9Yf"};